function getQueryParams(url) {
  const params = {};
  const queryString = new URL(url).search;
  const searchParams = new URLSearchParams(queryString);

  for (const [key, value] of searchParams.entries()) {
    if (params[key]) {
      params[key] = Array.isArray(params[key])
        ? [...params[key], value]
        : [params[key], value];
    } else {
      params[key] = value;
    }
  }

  return params;
}

window.addEventListener("DOMContentLoaded", () => {
  console.log("gtag.js loaded");
  const params = getQueryParams(window.location.href);
  const elements = document.querySelectorAll('a[href="/pages/booking"]');

  elements.forEach((element) => {
    const url = new URL(element.href, window.location.origin);
    // Push all query params from current URL to the link
    Object.entries(params).forEach(([key, value]) => {
      if (Array.isArray(value)) {
        value.forEach((v) => url.searchParams.append(key, v));
      } else {
        url.searchParams.set(key, value);
      }
    });
    element.href = url.toString();
  });
});
